// Detect whether browser is valid.
// By no means is this a finished product.
export default {
    modes: {
        IE11: 1,
        IE11compat: 2,
        IElt11: 3,
        notIE: 4,
    },

    getIEMode() {
        let agentStr = navigator.userAgent;
        console.log(`agentStr: ${agentStr}`);
        console.log('document');
        console.log(document);

        let mode;
        if (agentStr.indexOf('Trident/7.0') > -1) {
            if (agentStr.indexOf('MSIE') > -1) {
                // Defaults to 7????
                // mode = "IE11 compat";
                mode = this.modes.IE11compat;
            } else {
                // mode = "IE11";
                mode = this.modes.IE11;
            }
        } else if (agentStr.indexOf('Trident') > -1 /* || agentStr.indexOf("MSIE") > -1 */) {
            // mode = "IE7-"
            // mode="IE10-";
            mode = this.modes.IElt11;
        } else {
            // mode = "not IE";
            mode = this.modes.notIE;
        }
        return mode;
    },

    badBrowserWarning(productName) {
        let mode = this.getIEMode();
        let modes = this.modes;

        console.log(`Mode: ${mode}`);

        let text =
            mode === modes.IE11compat
                ? `${productName} supports Chrome, Firefox, Edge, and Internet Explorer 11.
                We are detecting your browser is set to “Compatibility mode” to emulate older browsers.
                ${productName} will not work with this setting.
                Please use a different browser or remove analog.com from your browser’s compatibility mode settings.`
                : `${productName} supports Chrome, Firefox, Edge, and Internet Explorer 11. 
                We are detecting your browser as an older version of Internet Explorer.
                Please use a different browser or update Internet Explorer.`;
        let title = mode === modes.IE11compat ? 'Compatibility Mode detected' : 'Old Internet Explorer detected';

        return {
            title: title,
            text: text,
        };
    },

    isGood() {
        let mode = this.getIEMode();
        let modes = this.modes;
        return mode === modes.IE11 || mode === modes.notIE;
    },
};
